module.exports = __webpack_public_path__ + "img/vip_room_min_4.6ef117d8.png";